import Vue from 'vue';
import IVueInstance from './IVueInstance';
import IFireBaseApp from './IFireBaseApp';
import Tools, { ITools } from './tools';

export default class CVueInstance extends Vue implements IVueInstance {
  public $firebase!: IFireBaseApp;
  public $setTitle!: any;
  public tools: ITools = new Tools();
  // tslint:disable-next-line:variable-name
  private _thisId: string | null = null;
  public GetMyId(): string {
    if (this.$data._thisId === undefined || this.$data._thisId === null) {
      this.$data._thisId = this.tools.guidGenerator();
    }
    return this.$data._thisId;
  }
}
